import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
import { computed, onBeforeUnmount, onMounted, ref, watch, } from 'vue';
import { routeName } from '@/constants/routeName';
import { convertCase } from '@/utils';
import ReportTable from '@/views/HubAdjustment/Daily/Report/ReportTable.vue';
import { hubDailyReportTableOptionTypeMapper } from '@/constants/hubAdjustment/daily';
import SubController from '@V/HubAdjustment/Daily/SalesDetail/SubController.vue';
import { i18n } from '@/locales';
import { useRoute, useRouter, } from 'vue-router';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import vuexStore from '@/vuex-store';
const wrapperClass = '';
// 각 type 별 테이블 헤더
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const isInitialized = ref(false);
        const isFetching = ref(true);
        const isError = ref(false);
        const resetStatus = () => {
            isFetching.value = true;
            isError.value = false;
        };
        // 구독중인 허브
        const getterSubscribeHubId = computed({
            get() { return vuexStore.getters['hubSelector/getterSubscribeHubId']; },
            set() { },
        });
        const getHubDailyReport = async () => {
            vuexStore.dispatch('hubAdjustment/hubDailyReport/resetHubDailyReport');
            resetStatus();
            try {
                const { message } = await vuexStore.dispatch('hubAdjustment/hubDailyReport/getHubDailyReport');
                if (message) {
                    vuexStore.dispatch(snackbarActionType.showError, {
                        message,
                    });
                }
            }
            catch (error) {
                console.log('hubAdjustment/Daily/SalesDetail/getHubDailyReport', error);
                isError.value = true;
            }
            isFetching.value = false;
        };
        watch(() => getterSubscribeHubId.value, (value) => {
            if (!isInitialized.value && !value) {
                return;
            }
            getHubDailyReport();
        });
        // 현재 정산 타입
        const currentReportType = computed({
            get() { return vuexStore.state.hubAdjustment.hubDailyReport.reportType; },
            set() { },
        });
        // 각 type 별 테이블 너비 차이 해소 (detail은 너무 넓어서 필요 x)
        const tableHeader = computed({
            get() {
                const type = currentReportType.value;
                if (!type) {
                    return [];
                }
                return hubDailyReportTableOptionTypeMapper[type]
                    .filter((item) => !item.downloadOnly);
            },
            set() { },
        });
        // 검색어
        const searchKeyword = computed({
            get() { return vuexStore.state.hubAdjustment.hubDailyReport.keyword; },
            set() { },
        });
        // 검색어 변경시 정산데이터 재호출
        watch(() => searchKeyword.value, (value) => {
            if (!isInitialized.value && !value) {
                return;
            }
            getHubDailyReport();
        });
        // 정산 호출 결과물
        const tableReport = computed({
            get() {
                const report = vuexStore.state.hubAdjustment.hubDailyReport.hubDailyReport;
                if (!report) {
                    return undefined;
                }
                return report;
            },
            set() { },
        });
        const tableData = computed({
            get() {
                const report = vuexStore.state.hubAdjustment.hubDailyReport.hubDailyReport;
                if (!report) {
                    return [];
                }
                return report.items;
            },
            set() { },
        });
        const handleClickReturnBtn = () => {
            const name = routeName.HUB_ADJUSTMENT_DAILY_SALES;
            const { params: { type, selectedMonth }, query } = route;
            router.push({
                name,
                params: {
                    type,
                    selectedMonth,
                },
                query,
            }).catch(() => { });
        };
        onMounted(async () => {
            const { date, selectedMonth } = route.params;
            const type = convertCase(`${route.params.type}-detail`, 'kebab', 'camel');
            const detailDate = selectedMonth.replace('-', '') + date.split('-')[1];
            vuexStore.dispatch('hubAdjustment/hubDailyReport/setReportType', type);
            vuexStore.dispatch('hubAdjustment/hubDailyReport/setDetailDate', detailDate);
            vuexStore.dispatch('hubAdjustment/hubDailyReport/resetFilterOptions');
            await getHubDailyReport();
            isInitialized.value = true;
        });
        onBeforeUnmount(() => {
            isInitialized.value = false;
            vuexStore.dispatch('hubAdjustment/hubDailyReport/resetHubDailyReport');
            vuexStore.dispatch('hubAdjustment/hubDailyReport/setReportType', '');
            vuexStore.dispatch('hubAdjustment/hubDailyReport/setDetailDate', '');
            vuexStore.dispatch('hubAdjustment/hubDailyReport/resetFilterOptions');
        });
        const locales = {
            goBack: i18n.t('common.go_back'),
        };
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(SubController),
                    _createVNode(ReportTable, {
                        "table-header": tableHeader.value,
                        "table-data": tableData.value,
                        report: tableReport.value,
                        "wrapper-class": wrapperClass,
                        "table-height": 608,
                        "is-error": isError.value,
                        "is-fetching": isFetching.value
                    }, null, 8 /* PROPS */, ["table-header", "table-data", "report", "is-error", "is-fetching"]),
                    _createCommentVNode(" 목록보기 "),
                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                        class: "list-btn mt-4",
                        onClick: handleClickReturnBtn
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, { small: "" }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createTextVNode(" mdi-chevron-left ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [0]
                            }),
                            _createTextVNode(" " + _toDisplayString(locales.goBack), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })), [
                        [
                            _directive_btn_style,
                            void 0,
                            "config",
                            {
                                info: true,
                                outlined: true,
                                "size-l": true,
                                "width-xs": true
                            }
                        ]
                    ])
                ])
            ]));
        };
    }
});
